import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const HazeIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" title={t`Haze`} {...props}>
    <Path fill="none" d="M0 0h20v20H0z" />
    <Path
      d="M6 14h12M2 11h8M4 17h6M14 10c0-2.21-1.717-4-3.835-4C8.85 6 7.69 6.69 7 7.74"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      fill="none"
    />
    <Path
      opacity={0.5}
      d="M10 1v2M17 10h2M14.951 5.05l1.414-1.413M5.05 5.05 3.638 3.638"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      fill="none"
    />
  </Icon>
);

export default HazeIcon;
